import { createAction, props } from '@ngrx/store';
import { FormControlStatus } from '@angular/forms';
import { ConfigValues } from '../config/models/config.model';
import { Project } from '../project/models/project.model';

export const AnchoredSectionValidated = createAction(
  '[Project Edit Form] Anchored Section Validated',
  props<{ anchor: string; count: number }>(),
);

export const ProjectFormStatusChanged = createAction(
  '[Project Form] Status Changed',
  props<{ status: FormControlStatus }>(),
);

export const ProjectEditFormLoadedAction = createAction(
  '[Project Edit Form] Form Loaded',
  props<{ project: Partial<Project> }>(),
);

export const ProjectEditFormDataStabilized = createAction(
  '[Project Edit Form] Form Data Stabilized',
  props<{ configValues: ConfigValues }>(),
);

export const ProjectEditFormExitedAction = createAction('[Project Edit Form] Form Exited');
